import React, { memo, forwardRef } from "react";
const SvgReplyArrow2Small = forwardRef((props, svgRef) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M20.25 9H8.25C5.76472 9 3.75 11.0147 3.75 13.5V13.5C3.75 15.9853 5.76472 18 8.25 18H18.75"
        stroke="#717171"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 5.25L20.25 9L16.5 12.75"
        stroke="#717171"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
SvgReplyArrow2Small.displayName = "SvgReplyArrow2Small";
const MemoForwardRef = memo(SvgReplyArrow2Small);
export default MemoForwardRef;
